import { Image } from '@chakra-ui/react';
import { Text } from '@mercator-gcp/grout';
import { Section } from 'components/layout/Section';

const containerStyle = {
  alignItems: 'center',
};

type TProps = {
  label: string;
  imageUrl: string;
  imageAlt: string;
};

const EmptyGroupPlaceholder = ({ label, imageUrl, imageAlt }: TProps) => {
  return (
    <Section label={<Text.Lead>{label}</Text.Lead>} description="" sx={containerStyle}>
      <Image boxSize="400px" src={imageUrl} alt={imageAlt} />
    </Section>
  );
};

export default EmptyGroupPlaceholder;
